module.exports = __webpack_public_path__ + "static/media/logo_text@2x.2f20bf5a.png";